import PropTypes from "prop-types";
import { propOr, pipe, find, prop } from "ramda";
import { formatDate, formatPhone } from "utils/misc";
import useTranslate from "hooks/use-translate-language";
import { TextInputReadOnly } from "components/form_new";

const Info = ({ patientInfo }) => {
  const translate = useTranslate();
  const getPhoneNumber = (primary, phone_numbers) =>
    pipe(
      propOr([], "phone_numbers"),
      find(x => x.primary == primary),
      prop("phone_number"),
      formatPhone
    )(phone_numbers);
  const homeAddress = propOr({}, "home_address", patientInfo);

  return (
    <div className="profile-panel">
      <div className="profile-panel-content">
        <TextInputReadOnly
          label={translate("name")}
          value={propOr("", "first_name", patientInfo)}
        />
        <TextInputReadOnly
          label={translate("lastName")}
          value={propOr("", "last_name", patientInfo)}
        />
        <TextInputReadOnly
          label={translate("email")}
          value={patientInfo.email}
        />
      </div>
      <div className="profile-panel-content">
        <TextInputReadOnly
          label={translate("primaryPhoneNumber")}
          value={getPhoneNumber(true, patientInfo)}
        />
        <TextInputReadOnly
          label={translate("secondaryPhoneNumber")}
          value={getPhoneNumber(false, patientInfo)}
        />
      </div>
      <fieldset className="accesibility-fieldset profile-panel-content">
        <TextInputReadOnly
          label={translate("streetAddress")}
          value={homeAddress.street_address || ""}
        />
        <TextInputReadOnly
          label={translate("streetAddress2")}
          value={homeAddress.street_address2 || ""}
        />
        <TextInputReadOnly
          label={translate("city")}
          value={homeAddress.city || ""}
        />
        <TextInputReadOnly
          label={translate("state")}
          value={homeAddress.state || ""}
        />
        <TextInputReadOnly
          label={translate("zipCode")}
          value={homeAddress.zip || ""}
        />
      </fieldset>
      <fieldset className="accesibility-fieldset profile-panel-content">
        <TextInputReadOnly
          label={translate("primaryLanguage")}
          value={patientInfo?.speaks_spanish ? "Español" : "English"}
        />
        <TextInputReadOnly
          label={translate("eligibleForSupplies")}
          value={formatDate(patientInfo.insurance_eligibility_date)}
        />
      </fieldset>
    </div>
  );
};

Info.propTypes = { patientInfo: PropTypes.object.isRequired };

export default Info;
